import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { FeaturedCardListComponent } from 'src/app/shared/partials/featured-card-list/featured-card-list.component'
import { BreadcrumbsComponent } from '../../shared/partials/breadcrumbs/breadcrumbs.component'
import { DataVisualizationPanelComponent } from '../../shared/partials/data-visualization-panel/data-visualization-panel.component'
import { FeaturedCardComponent } from '../../shared/partials/featured-card/featured-card.component'
import { PostCardComponent } from '../../shared/resources/post/post-card/post-card.component'
import { VideoCardComponent } from '../../shared/resources/video/video-card/video-card.component'
import { GenerativeAiRoutingModule } from './generative-ai.routes'
import { GenerativeAiDataComponent } from './pages/generative-ai-data/generative-ai-data.component'
import { GenerativeAiExternalResourcesComponent } from './pages/generative-ai-external-resources/generative-ai-external-resources.component'
import { GenerativeAiIssuesComponent } from './pages/generative-ai-issues/generative-ai-issues.component'
import { GenerativeAiOverviewComponent } from './pages/generative-ai-overview/generative-ai-overview.component'
import { GenerativeAiPoliciesAndInitiativesComponent } from './pages/generative-ai-policies-and-initiatives/generative-ai-policies-and-initiatives.component'
import { GenerativeAiPublicationsComponent } from './pages/generative-ai-publications/generative-ai-publications.component'
import { GenerativeAiVideosComponent } from './pages/generative-ai-videos/generative-ai-videos.component'
import { HeadGenerativeAiComponent } from './partials/head-generative-ai/head-generative-ai.component'
import { TabsResourcesGenerativeAiComponent } from './partials/tabs-resources-generative-ai/tabs-resources-generative-ai.component'

@NgModule({
  declarations: [
    GenerativeAiDataComponent,
    GenerativeAiExternalResourcesComponent,
    GenerativeAiIssuesComponent,
    GenerativeAiOverviewComponent,
    GenerativeAiPoliciesAndInitiativesComponent,
    GenerativeAiPublicationsComponent,
    GenerativeAiVideosComponent,
    HeadGenerativeAiComponent,
    TabsResourcesGenerativeAiComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    GenerativeAiRoutingModule,

    // Standalone.
    BreadcrumbsComponent,
    VideoCardComponent,
    FeaturedCardComponent,
    FeaturedCardListComponent,
    PostCardComponent,
    DataVisualizationPanelComponent
  ]
})
export class GenerativeAiModule {}
